export default {
  state: {
    map: {
      showPolygons: false,
      rsvp: null,
      drivers: [],
      sector: null,
      gap: null,
      kml: 0,
      kmls: []
    },
    trigger: {
      watch: false,
      action: '',
      data: ''
    }
  },
  mutations: {
    setCoverageMapShowPolygons (state, value) {
      state.map.showPolygons = value
      state.map.sector = null
      state.map.rsvp = null
      state.map.gap = null
    },
    setCoverageMapRsvp (state, value) { state.map.rsvp = value },
    setCoverageMapDrivers (state, value) { state.map.drivers = value },
    setCoverageMapSector (state, value) { state.map.sector = value },
    setCoverageMapGap (state, value) { state.map.gap = value },
    setCoverageMapKml (state, value) { state.map.kml = value },
    setTriggerWatch (state, value) { state.trigger.watch = value },
    setTriggerAction (state, value) { state.trigger.action = value },
    setTriggerData (state, value) { state.trigger.data = value },
    addKml (state, id) {
      let i = state.map.kmls.indexOf(id)
      if (i == -1) {
        state.map.kmls.push(id)
      }
    },
    removeKml (state, id) {
      let i = state.map.kmls.indexOf(id)
      if (i > -1) {
        state.map.kmls.splice(i, 1)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/coverage/coverage-map.js